export const removeQueryParams = url => {
    return  url.split('?')[0];
}